import React, { useImperativeHandle } from 'react';
import { find } from 'lodash-es';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTheme } from '@material-ui/core/styles';
import {
  Daystoadmitdeadline,
  Daystodischargedeadline,
  Approval,
  Download,
  Cmsapproved,
  APPROVE,
  CMS_ACCEPTANCE,
  greenColor,
} from './constants';
import { DIS, ADM, ACCPT, SENT, APR, DWN } from '../Context/constants';
import {
  CellDiv,
  StyledSpan,
  StyledButton,
  DownloadIcon,
} from '../../components/layout/WrapperDiv';
import { HisAdminStatusShortName, CellType } from './types';
import defaults from '../../translations/en.json';

export const QuotaCellRenderer = React.forwardRef((props: any, ref) => {
  useImperativeHandle(ref, () => ({
    getReactContainerClasses() {
      return ['custom-cell'];
    },
    getReactContainerStyle() {
      return {
        display: 'inline-block',
        width: '100%',
      };
    },
  }));

  const {
    palette: { grey },
  } = useTheme() as any;
  let title: any;

  const { postData, data } = props;

  const actualPatientStatus = data && data.type;

  // can be []
  const value = props && props.value && props.value.value;
  const postPatientStatus =
    value &&
    value.ADM &&
    find(value.ADM, {
      hisadminstatusshortname: ACCPT,
    })
      ? DIS
      : ADM;

  const patientStatus =
    actualPatientStatus === ADM ? actualPatientStatus : postPatientStatus;

  // eslint-disable-next-line consistent-return
  const getCellUI = (
    type?: CellType,
    text?: string,
    color?: string,
    shortName?: HisAdminStatusShortName,
  ) => {
    switch (type) {
      case 'string':
        return (
          <CellDiv className="custom-cell">
            <StyledSpan color={color}>{text}</StyledSpan>
          </CellDiv>
        );
      case 'button': // can be APPROVE or CMS ACCEPTANCE => can be a post or a put
        return (
          <CellDiv className="custom-cell">
            <StyledButton
              variant="contained"
              style={{ backgroundColor: greenColor }}
              onClick={() => postData(shortName, 'POST', patientStatus, data)}
            >
              {text}
            </StyledButton>
          </CellDiv>
        );
      case 'downloaded':
        return (
          <CellDiv className="custom-cell">
            <StyledButton
              id="downloaded"
              variant="contained"
              color="primary"
              style={{ backgroundColor: greenColor }}
              onClick={() => postData(DWN, 'POST', patientStatus, data)}
            >
              {defaults.download}
            </StyledButton>
          </CellDiv>
        );
      case 'sent':
        return (
          <CellDiv className="custom-cell">
            <DownloadIcon>
              <GetAppIcon
                onClick={() => postData(DWN, 'POST', patientStatus, data)}
              />
            </DownloadIcon>
            <StyledButton
              id="sent"
              variant="contained"
              color="primary"
              style={{ backgroundColor: greenColor }}
              onClick={() => postData(SENT, 'POST', patientStatus, data)}
            >
              {defaults.marksent}
            </StyledButton>
          </CellDiv>
        );
      default:
        return <CellDiv className="custom-cell"></CellDiv>;
    }
  };

  const getStringValue = (stringdata: any, text: string) => {
    let newValue;
    const { personlastname, personfirstname, statusdate } = stringdata;
    if (personfirstname && personlastname) {
      newValue = `${text} by ${personfirstname} ${personlastname} on ${statusdate}`;
    } else {
      newValue = `${text} on ${statusdate}`;
    }
    return newValue;
  };

  const getUI = () => {
    let type: CellType = null;
    let color;
    let newValue;
    let shortName: HisAdminStatusShortName = null;
    const dataValue = (value && value[actualPatientStatus]) || [];
    if (title === Daystoadmitdeadline || title === Daystodischargedeadline) {
      newValue = value;
      type = 'string';
    }
    if (title === Approval) {
      shortName = APR;
      if (!dataValue.length) {
        newValue = APPROVE;
        type = 'button';
      }
      if (dataValue.length) {
        color = grey['50'];
        type = 'string';
        const approved = find(dataValue, {
          hisadminstatusshortname: APR,
        });
        if (approved) {
          newValue = getStringValue(approved, 'Approved');
        }
      }
    }
    if (title === Download) {
      if (dataValue.length) {
        const approved = find(dataValue, {
          hisadminstatusshortname: APR,
        });
        const downloaded = find(dataValue, {
          hisadminstatusshortname: DWN,
        });
        const sent = find(dataValue, {
          hisadminstatusshortname: SENT,
        });

        if (sent) {
          newValue = getStringValue(sent, 'Sent');
          type = 'string';
          color = grey['50'];
        } else if (approved && downloaded) {
          type = 'sent';
          newValue = SENT;
          shortName = SENT;
        } else if (approved && !downloaded) {
          type = 'downloaded';
        }
      }
    }
    if (title === Cmsapproved) {
      if (dataValue.length) {
        const sent = find(dataValue, {
          hisadminstatusshortname: SENT,
        });
        const cmsAccepted = find(dataValue, {
          hisadminstatusshortname: ACCPT,
        });

        if (cmsAccepted) {
          newValue = getStringValue(cmsAccepted, 'CMS Accepted');
          type = 'string';
          color = grey['50'];
        } else if (sent) {
          newValue = CMS_ACCEPTANCE;
          type = 'button';
          shortName = ACCPT;
        }
      }
    }

    return getCellUI(type, newValue, color, shortName);
  };
  return getUI();
});

export const FormsCellRenderer = React.memo((props: any) => {
  const { data } = props && props;
  const {
    formpersoncredentials,
    formpersonfirstname,
    formpersonlastname,
    formdate,
    formname,
  } = data;
  let text;
  if (formpersonlastname && formpersonlastname && formdate) {
    text = `${formname} by ${formpersoncredentials} ${formpersonfirstname} ${formpersonlastname} on ${formdate}`;
  } else {
    text = `${formname}`;
  }

  return (
    <CellDiv>
      <span>{text}</span>
    </CellDiv>
  );
});
